import React from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import ResponsiveTabs from "../ResponsiveTabs";
import ContentActionMenu from "../ContentActionMenu";
import { ContentHeaderBarWrapper } from "./_.styled";

const ContentHeaderBar = ({
  actions,
  tools,
  tabs,
  recordAn,
  isMobile,
  getSectionName,
  activeDrugDetailSection,
  telemetryData,
  activeTabPath,
}) => {
  const { tabType = null } = useParams(); // Grab our tabType or default to null for main tab

  const toolsForThisTabType = (tabTools) => {
    return tabTools?.filter(
      (tool) =>
        tool.whiteListTabTypes?.includes("any") ||
        tool.whiteListTabTypes?.includes(tabType)
    );
  };
  const filteredTools = toolsForThisTabType(tools);

  return (
    <ContentHeaderBarWrapper
      data-testid="content-header-bar-wrapper"
      id="content-header-bar-wrapper"
    >
      <ResponsiveTabs
        tabs={tabs}
        tabType={tabType}
        getSectionName={getSectionName}
        activeDrugDetailSection={activeDrugDetailSection}
        telemetryData={telemetryData}
        activeTabPath={activeTabPath}
      />
      {filteredTools?.length > 0 && (
        <ContentActionMenu
          actions={actions}
          tools={filteredTools}
          an={recordAn}
          isMobile={isMobile}
        />
      )}
    </ContentHeaderBarWrapper>
  );
};

ContentHeaderBar.propTypes = {
  actions: PropTypes.object.isRequired,
  tools: PropTypes.array.isRequired,
  tabs: PropTypes.array.isRequired,
  tabType: PropTypes.string,
  recordAn: PropTypes.string.isRequired,
  activeDrugDetailSection: PropTypes.string,
};

ContentHeaderBar.defaultProps = {};
ContentHeaderBar.displayName = "ContentHeaderBar";

export default ContentHeaderBar;
